import { orchestrator } from 'satcheljs';
import {
    switchToFullCompose,
    prepareEvent,
    closeComposeForm,
} from 'owa-calendar-compose-form-actions';
import { getQuickComposeViewState, getComposeEvent } from 'owa-calendar-compose-store-manager';
import { lazyShowFullCompose } from 'owa-calendar-compose-form-store';
import {
    CharmSelectionType,
    FullComposeFormViewType,
} from 'owa-calendar-helpers-types/lib/ComposeTypes';
import addTab from 'owa-tab-store/lib/utils/addTab';
import { TabType } from 'owa-tab-store';
import { addPopoutV2 } from 'owa-popout-v2';
import { FluidOwaSource, isFluidEnabledForSource } from 'owa-fluid-validations';
import {
    getOpenCalendarFullComposeActionType,
    tryStartFullComposePerfDatapoint,
    OpenCalendarFullComposeActionType,
} from 'owa-calendar-compose-form-utils';

const CALENDAR_POPOUT_WINDOW_SIZE = {
    width: 1095,
    height: 640,
};

orchestrator(switchToFullCompose, async actionMessage => {
    const {
        formId,
        entrySource,
        shouldOpenSchedulingAssistant,
        createCollabSpaceOnInitProps,
    } = actionMessage;

    prepareEvent(formId);

    const isCharmExplicitlySet =
        getQuickComposeViewState(formId).charmSelection == CharmSelectionType.Manual;

    const event = getComposeEvent(formId);

    closeComposeForm(
        formId,
        event.IsMeeting,
        false /* shouldResetComposeStore */,
        false /* shouldClosePopOutWindow */
    );

    const actionType = getOpenCalendarFullComposeActionType();

    await tryStartFullComposePerfDatapoint(
        actionType,
        formId,
        true /* bundleAlreadyLoaded */,
        entrySource
    );

    if (actionType == OpenCalendarFullComposeActionType.Modal) {
        lazyShowFullCompose.importAndExecute(
            isCharmExplicitlySet,
            entrySource,
            FullComposeFormViewType.Modal,
            shouldOpenSchedulingAssistant /* shouldOpenSchedulingAssistant */,
            undefined /* extractionSourceId */,
            undefined /* internetMessageId */,
            createCollabSpaceOnInitProps,
            formId
        );
    } else if (actionType == OpenCalendarFullComposeActionType.ProjectionPopout) {
        const tabId = addTab(
            TabType.CalendarCompose,
            false /* isShown */,
            false /* makeActive */,
            formId
        );

        lazyShowFullCompose.importAndExecute(
            isCharmExplicitlySet,
            entrySource,
            FullComposeFormViewType.ProjectionPopOut,
            shouldOpenSchedulingAssistant /* shouldOpenSchedulingAssistant */,
            undefined /* extractionSourceId */,
            undefined /* internetMessageId */,
            createCollabSpaceOnInitProps,
            formId
        );

        addPopoutV2(
            'calendar',
            'compose',
            {
                projectionTabId: tabId,
            },
            CALENDAR_POPOUT_WINDOW_SIZE
        );
    } else {
        addPopoutV2(
            'calendar',
            'compose',
            {
                composeConfig: {
                    fullComposeEntrySource: entrySource,
                    eventUpdates: event,
                    itemHasUpdates: true,
                    createCollabSpaceOnInitProps: createCollabSpaceOnInitProps,
                    shouldOpenSchedulingAssistant: shouldOpenSchedulingAssistant,
                },
                includeFluidOnPopout: isFluidEnabledForSource(FluidOwaSource.CalendarCompose),
            },
            CALENDAR_POPOUT_WINDOW_SIZE
        );
    }
});
